import moment from 'jalali-moment';
import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Grid, Image, Typography } from '@iho-design-system/Loader';

/*
    - icon
*/
import ArrowDownSVG from '../../../assets/images/icons/arrow-down.svg';
import ArrowUpSVG from '../../../assets/images/icons/arrow-up.svg';
import EmptySVG from '../../../assets/images/icons/empty.svg';
import LoadingCustomSVG from '../../../assets/images/icons/loading-custom.svg';
import PaginationLeftSVG from '../../../assets/images/icons/pagination-left.svg';
import PaginationRightSVG from '../../../assets/images/icons/pagination-right.svg';

const List = ({ props, paginationProps }) => {
    /*
       - defaultData
    */
    const [walletReportResult, setWalletReport] = React.useState('loading');

    React.useEffect(() => {
        if (props.walletReport !== '') {
            if (props.walletReport.status === 200 && props.walletReport.data.Data.length > 0) {
                setWalletReport(props.walletReport.data);
            } else {
                setWalletReport('empty')
            }
        }
    }, [props]);

    if (walletReportResult === 'loading') {
        return (
            <Image
                className={`d-block mx-auto`}
                src={LoadingCustomSVG}
                ms={{
                    width: '40px',
                    height: '40px'
                }} />
        );
    }

    if (walletReportResult === 'empty') {
        return (
            <React.Fragment>
                <Box>
                    <Image
                        className={`mx-auto`}
                        src={EmptySVG}
                        ms={{
                            display: 'block',
                            width: '120px',
                            height: '120px'
                        }} />
                    <Typography
                        className={`d-block my-md text-center`}
                        component='h2'>
                        گزارشات مالی شما خالی است :(
                    </Typography>
                    <Typography
                        className={`d-block text-center`}
                        component='strong'>
                         تاکنون هیچ گزارشی ثبت نشده است!
                    </Typography>
                </Box>
            </React.Fragment>
        );
    }

    if (walletReportResult !== 'empty') {
        return (
            <React.Fragment>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            size='col-12'>
                            <Box
                                ms={{
                                    '@media(max-width:992px)': {
                                        overflowX: 'scroll'
                                    }
                                }}>
                                <Box
                                    ms={{
                                        minWidth: '992px'
                                    }}>
                                    <Box
                                        className={`d-inline-block w-100 my-sm mt-0 px-xl py-lg rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--gray-light)'
                                        }}>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                ردیف
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                تاریخ پرداخت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                            مبلغ (تومان)
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                شناسه پرداخت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                وضعیت
                                            </Typography>
                                        </Box>
                                        <Box
                                            className={`d-inline-block`}
                                            ms={{
                                                width: '16.6666%'
                                            }}>
                                            <Typography>
                                                توضیحات
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box
                                        className={`border-solid border-light rounded-sm`}
                                        ms={{
                                            backgroundColor: 'var(--white)'
                                        }}>
                                        {walletReportResult.Data.map((obj, index) => {
                                            return (
                                                <Box
                                                    key={index}>
                                                    <Box
                                                        className={`d-flex justify-content-between px-lg py-md border-solid-bottom border-light`}>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {index + 1}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {moment(obj.AddDate.split('T')[0], 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD')}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {obj.DepositPrice !== 0 &&
                                                                <Box
                                                                    component='span'>
                                                                    {(obj.DepositPrice / 10).toLocaleString()}
                                                                </Box>
                                                            }
                                                            {obj.WithdrawalPrice !== 0 &&
                                                                <Box
                                                                    component='span'>
                                                                    {(obj.WithdrawalPrice / 10).toLocaleString()}
                                                                </Box>
                                                            }
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {obj.ReferenceId}
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {obj.DepositPrice !== 0 &&
                                                                <React.Fragment>
                                                                    <Image
                                                                        src={ArrowDownSVG}
                                                                        ms={{
                                                                            display: 'inline',
                                                                            width: '16px',
                                                                            height: '16px'
                                                                        }} />
                                                                    <Typography
                                                                        ms={{
                                                                            color: 'var(--green-medium)'
                                                                        }}>
                                                                        واریز
                                                                    </Typography>
                                                                </React.Fragment>
                                                            }
                                                            {obj.WithdrawalPrice !== 0 &&
                                                                <React.Fragment>
                                                                    <Image
                                                                        src={ArrowUpSVG}
                                                                        ms={{
                                                                            display: 'inline',
                                                                            width: '16px',
                                                                            height: '16px'
                                                                        }} />
                                                                    <Typography
                                                                        ms={{
                                                                            color: 'var(--red-medium)'
                                                                        }}>
                                                                                برداشت
                                                                    </Typography>
                                                                </React.Fragment>
                                                            }
                                                        </Box>
                                                        <Box
                                                            ms={{
                                                                width: '16.6666%'
                                                            }}>
                                                            {obj.Description}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            );
                                        })}
                                        <Box
                                            className={`d-flex justify-content-center rounded-sm rounded-top-right-0 rounded-top-left-0`}
                                            ms={{
                                                height: '56px',
                                                backgroundColor: 'var(--gray-ultra-light)'
                                            }}>
                                            <Box
                                                className={`d-flex justify-content-center align-item-center`}
                                                ms={{
                                                    gap: '16px'
                                                }}>
                                                <Button
                                                    onClick={() => paginationProps(-1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationRightSVG} />
                                                </Button>
                                                <Typography
                                                    className={`text-primary`}>
                                                    {walletReportResult.PageIndex} / {Math.ceil(walletReportResult.TotalItems / walletReportResult.PageSize)}
                                                </Typography>
                                                <Button
                                                    onClick={() => paginationProps(1)}
                                                    className={`p-0 rounded-lg`}
                                                    variant='outlined'
                                                    color='primary'
                                                    ms={{
                                                        width: '30px !important',
                                                        height: '30px !important',
                                                        backgroundColor: 'var(--white) !important',
                                                        borderColor: 'var(--white) !important',
                                                        boxShadow: 'var(--shadow-dark)'
                                                    }}>
                                                    <Image
                                                        src={PaginationLeftSVG} />
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </React.Fragment>
        );
    }

}

export default List;